import { WrapperCookies } from '@/styles/pages/cookies';
import { GetStaticPaths, GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import Head from 'next/head';

const CookiePolicy = () => {
  const { t } = useTranslation('cookies');

  return (
    <>
      <Head>
        <title>{t('title')}</title>
      </Head>

      <WrapperCookies>
        <div className="cookies-1">
          <h1>{t('cookiesub-1.h1')}</h1>
          <p>{t('cookiesub-1.p')}</p>
        </div>
        <div className="apps" />

        <section className="partnership2">
          <div>
            <h1>{t('cookies.h1')}</h1>
            <p>{t('cookies.1.p')}</p>
            <br />
            <p>{t('cookies.2.p')}</p>

            <h1
              style={{
                marginTop: '45px'
              }}
            >
              {t('cookies-2.h1')}
            </h1>
            <p>{t('cookies-2.p')}</p>
          </div>
          <div>
            <h2 style={{ marginTop: '80px', marginBottom: '90px' }}>
              {t('cookiesub-2.h2')}
            </h2>
          </div>
          <div>
            <h1>{t('cookies-3.h1')}</h1>
            <p>{t('cookies-3.1.p')}</p>
            <br />
            <p>{t('cookies-3.2.p')}</p>
            <br />
            <p>{t('cookies-3.3.p')}</p>

            <h1 style={{ marginTop: '45px' }}>{t('cookies-4.h1')}</h1>
            <p>{t('cookies-4.p')}</p>

            <h1 style={{ marginTop: '45px' }}>{t('cookies-5.h1')}</h1>
            <p>{t('cookies-5.1.p')}</p>
            <br />
            <p>{t('cookies-5.2.p')}</p>

            <h1 style={{ marginTop: '45px' }}>{t('cookies-6.h1')}</h1>
            <p>{t('cookies-6.p')}</p>

            <h1 style={{ marginTop: '45px' }}>{t('cookies-7.h1')}</h1>
            <p>{t('cookies-7.1.p')}</p>
            <br />
            <p>{t('cookies-7.2.p')}</p>

            <h1 style={{ marginTop: '45px' }}>{t('cookies-8.h1')}</h1>
            <p>{t('cookies-8.p')}</p>
            <br />
            <p>{t('cookies-8.1.p')}</p>
            <p>{t('cookies-8.2.p')}</p>
            <p>{t('cookies-8.3.p')}</p>
            <p>{t('cookies-8.4.p')}</p>
          </div>
        </section>
      </WrapperCookies>
    </>
  );
};

export const getStaticPaths: GetStaticPaths = async () => ({
  paths: [
    {
      params: {
        cookie: 'cookies-policy'
      },
      locale: 'en'
    },
    {
      params: {
        cookie: 'politica-de-cookies'
      },
      locale: 'br'
    }
  ],
  fallback: false
});

export const getStaticProps: GetStaticProps = async (context) => {
  const {
    params: { cookie },
    locale
  } = context;

  return {
    props: {
      ...(await serverSideTranslations(locale.toString())),
      cookie
    }
  };
};

export default CookiePolicy;
